import React from 'react';
import classnames from 'classnames';

const ProgressBar = ({className, progress}) => {
  const cssBEM = 'progressBar';
  const classes = classnames(cssBEM, className);
  const progressValue = Math.round(progress);

  return <div className={classes} role="progressbar" aria-valuenow={progress || 1} aria-valuemin="0" aria-valuemax="100">

    <div className={`${cssBEM}__indicator`} style={{paddingLeft:  `${(progress || 1) - 6}%`}}>
      {progressValue}%
    </div>

    <div className={`${cssBEM}__wrapper`}>
      <div className={`${cssBEM}__status`}
        style={{width: `${progress || 1}%`}}
      />
    </div>
  </div>;
};

export default ProgressBar;
